import React, { useState, useEffect, useCallback } from "react";
import {
  Layout,
  Button,
  DatePicker,
  TimePicker,
  notification,
  Tooltip,
  Modal,
  Space,
} from "antd";
import { Row, Form, Input, Col, Select, Typography, Checkbox } from "antd";
import {
  FileSearchOutlined,
  InfoCircleFilled,
  PlusCircleFilled,
  ShoppingOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";

import TopHeader from "../common/TopHeader/TopHeader";
import Sidebar from "../common/Sidebar/Sidebar";
import RecipeApi from "../common/Apis/RecipeApi";
import dayjs from "dayjs";
import moment from "moment";
import ProductionApi from "../common/Apis/ProductionApi";
import StockApi from "../common/Apis/StockApi";
import AftreCookApi from "../common/Apis/AftreCookApi";
import ColdTraceabilityApi from "../common/Apis/ColdTraceabilityApi";
import StorageSelectProduction from "../common/DropDowns/Stock/StorageSelectProduction";
import RuntimeConfigsApi from "../common/Apis/RuntimeConfigsApi";
import ProductApi from "../common/Apis/ProductApi";
import EmptyBox from "../common/CommonUI/EmptyBox";

const { Text } = Typography;

const ListProduction = () => {
  let navigate = useNavigate();
  const { Title } = Typography;
  const { Content } = Layout;
  const [formAdd] = Form.useForm();
  const [formAdd2] = Form.useForm();
  const [SelectRecipe, setSelectRecipe] = React.useState();
  const [Ingredients, setIngredients] = React.useState([]);
  const UserDetails = JSON.parse(localStorage.getItem("UserDetails"));
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const CURRENCY = decodedToken.currency === "USD" ? "$" : "€";
  const [stockLoading, setStockLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  const [Recipes, setRecipe] = React.useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [SellByDay, setSellByDay] = useState(0);
  const currentDate = moment().format("DD/MM/YYYY");
  const currentTime = moment().format("h:mm a");

  const [loading, setLoading] = useState(false);
  const [TotalPageNew, setTotalPageNew] = useState(null);
  const [page, setPage] = useState(0);

  const extractCodeAfterHash = (productCode) => {
    if (!productCode) return null;

    const hashIndex = productCode.lastIndexOf("#");

    if (hashIndex !== -1) {
      return productCode.substring(hashIndex + 1);
    }

    return productCode;
  };

  const fetchDepartments = async () => {
    try {
      setLoading(true);
      RecipeApi.ListRecipe(page, 10)
        .then((response) => {
          setTotalPageNew(response.totalPages);
          setRecipe((prevDepartments) => [
            ...prevDepartments,
            ...response?.payloadDto,
          ]);
          setPage((prevPage) => prevPage + 1);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    } catch (error) {
      console.error("Error fetching departments:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    const nearBottom =
      e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 1;
    if (bottom || nearBottom) {
      if (TotalPageNew > page) {
        fetchDepartments();
      }
    }
  };
  const [time, setTime] = useState(new Date());

  const [RuntimeConfigs, setRuntimeConfigs] = React.useState([]);
  const getRuntimeConfigsApi = useCallback(() => {
    RuntimeConfigsApi.ListRuntimeConfigs()
      .then((response) => {
        setRuntimeConfigs(
          response.payloadDto.filter(
            (item) => item?.tag === "CURRENCY_TYPE_CONFIG"
          )
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    PageLoading();
    fetchDepartments();
    getRuntimeConfigsApi();
    const intervalID = setInterval(() => {
      setTime(new Date());
    }, 1000);
  }, [PageLoading, getRuntimeConfigsApi]);

  const formattedTimeNew = time.toLocaleTimeString();

  const handleSubmit = (data) => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    const dateObject = new Date("January 1, 2022 " + formattedTimeNew);
    const hours = dateObject.getHours();
    const minutes = dateObject.getMinutes();
    const formattedTime = `${hours}:${minutes < 10 ? "0" : ""}${minutes}`;

    const SelectDate = dayjs(data.prodDate).format("DD/MM/YYYY");
    const sellDate = dayjs(data.SellDate).format("DD/MM/YYYY");
    const prodTimeN = dayjs(data.prodTime).format("DD/MM/YYYY");

    const stockBatchCodeList = [];
    AfterStockProduct.forEach(ingredient => {
      if (ingredient.ingredientsQuantityDTOList) {
        ingredient.ingredientsQuantityDTOList.forEach(stockItem => {
          if (stockItem.batchCode && stockItem.stockId) {
            stockBatchCodeList.push(`${stockItem.batchCode}//${stockItem.stockId}`);
          }else if (stockItem.batchCode) {
          // Fallback: if no stockId, just use the batch code
          stockBatchCodeList.push(stockItem.batchCode);
        }
        });
      }
    });

    let formData = JSON.stringify({
      cookingTime: formattedTime,
      sellByDate: convertToUnixTimestamp(sellDate),
      unit: SelectRecipe?.unit,
      quantity: SelectRecipe?.quantity,
      productionName: SelectRecipe?.recipeName,
      currency: CURRENCY,
      userId: decodedToken?.userId,
      productionCoast: changeTotalCost(),
      productionCreateDate: convertToUnixTimestamp(SelectDate),
      uomNumber: 3,
      rawProduction: false,
      stockBatchCodeList: stockBatchCodeList,
      recipeDTO: {
        id: data?.type,
        ingredientsDTO: AfterStockProduct,
      },
      allergensDTO: SelectRecipe.allergenDTOList,
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
      institutionDTO: {
        id: SelectRecipe?.institutionDTO?.id,
      },
    });

    
    ProductionApi.CreateProduction(formData)
      .then((response) => {
        if (data.storageUnit) {
          let formData2 = JSON.stringify({
            coldTraceabilityTime: convertToUnixTimestamp(prodTimeN),
            coldTraceabilityDate: convertToUnixTimestamp(SelectDate),
            temp: "N/A",
            storageDTO: {
              id: data.storageUnit,
            },
            correctiveAction: "",
            productionDTO: {
              id: response?.payload?.id,
            },
            tenantDTO: {
              id: decodedToken?.tenantId,
              tenantApiKey: decodedToken?.tenantApiKey,
            },
            institutionDTO: {
              id: SelectRecipe?.institutionDTO?.id,
            },
            quantityOfTheCookedProduct: response?.payload?.recipeDTO?.quantity
          });

          ColdTraceabilityApi.Createcoldtraceability(formData2)
            .then((response22) => {
              notification.open({
                message: <span style={{ fontWeight: "bold" }}>Created</span>,
                description: "Created Successfully",
                closeIcon: false,
                duration: 3,
                style: {
                  backgroundColor: "#b3ffb3",
                  color: "green",
                },
              });
              return navigate("/cold-traceability");
            })
            .catch((err) => {
              console.log(err);
              if (err.apiError.status) {
                notification.open({
                  message: (
                    <span style={{ fontWeight: "bold" }}>
                      {err.apiError.status}
                    </span>
                  ),
                  description: err.apiError.message,
                  closeIcon: false,
                  duration: 3,
                  style: {
                    backgroundColor: "#fff2f0",
                    color: "red",
                  },
                });
              }
            });
        } else {
          let formData2 = JSON.stringify({
            dateOfCooking: response?.payload?.productionCreateDate,
            timeOfCookingFinished: formattedTime,
            temperatureOfTheProductAfterCook: "N/A",
            batchCodeOfTheCookedProduct: SelectRecipe?.batchCode,
            newSellByDateOfTheCookedProduct: convertToUnixTimestamp(sellDate),
            quantityOfTheCookedProduct: SelectRecipe?.recipeDTO?.quantity,
            temp: "N/A",
            description: "",
            quantityOfTheCookedProduct: response?.payload?.recipeDTO?.quantity,
            unit: SelectRecipe?.unit,
            productionDTO: {
              id: response?.payload?.id,
              institutionDTO: {
                id: response?.payload?.institutionDTO?.id,
              },
            },
            institutionDTO: {
              id: SelectRecipe?.institutionDTO?.id,
            },
            tenantDTO: {
              id: decodedToken?.tenantId,
              tenantApiKey: decodedToken?.tenantApiKey,
            },
          });
          AftreCookApi.CreateAftreCook(formData2)
            .then((response22) => {
              notification.open({
                message: <span style={{ fontWeight: "bold" }}>Created</span>,
                description: "Created Successfully",
                closeIcon: false,
                duration: 3,
                style: {
                  backgroundColor: "#b3ffb3",
                  color: "green",
                },
              });
              return navigate("/after-cook");
            })
            .catch((err) => {
              console.log(err);
              if (err.apiError.status) {
                notification.open({
                  message: (
                    <span style={{ fontWeight: "bold" }}>
                      {err.apiError.status}
                    </span>
                  ),
                  description: err.apiError.message,
                  closeIcon: false,
                  duration: 3,
                  style: {
                    backgroundColor: "#fff2f0",
                    color: "red",
                  },
                });
              }
            });
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.apiError.status) {
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  const [modalStockRecipeVisible, setStockRecipe] = useState(false);
  const [StockRecipeDatas, setStockRecipeData] = useState(false);
  const [StockProduct2, setStockProduct2] = React.useState();
  const [ShelfLifeProduct, setShelfLifeProduct] = React.useState();
  const [StockProductNew, setStockProductNew] = React.useState([]);

  // Function to filter out stock items with quantities less than 0.01
  const getFilteredStockProduct = React.useCallback(() => {
    if (!StockProductNew || StockProductNew.length === 0) return [];
    
    return StockProductNew.filter(item => {
      const uom1 = parseFloat(item.unitOfMeasurement1);
      
      // Skip if unitOfMeasurement1 is 0 or less
      if (uom1 <= 0) return false;
      
      // Skip if uom1 is less than 0.01
      if (uom1 < 0.01) return false;
      
      // Calculate UOM2 value
      const uom2Value = uom1 / parseFloat(StockProduct2?.unitOfMeasurement2 || 1);
      
      // Skip if UOM2 value is 0 or less, or less than 0.01
      if (uom2Value <= 0 || uom2Value < 0.01) return false;
      
      return true;
    });
  }, [StockProductNew, StockProduct2]);

 const addStockRecipe = (item) => {
  setSelectedItems([]);
  setValidateAddStore([]);
  setStockRecordSelectedValid(false);
  setStockRecipe(true);
  setStockRecipeData(item);
  setStockProduct2(item?.productDTO);
  setStockProductNew([]);
  setStockLoading(true);

  // First, get the product details to extract barcode
  ProductApi.SingleProducts(item?.productDTO?.id)
    .then(async (response2) => {
      setShelfLifeProduct(response2?.payload);

      const productCode = response2?.payload?.productCode;
      const barCode = extractCodeAfterHash(productCode);
      
      // Initialize with empty array
      let allStocks = [];
      let barcodeProducts = [];
      let barcodeStocks = [];

      try {
        // Get initial stock for the selected product (this is mandatory)
        const stockResponse = await StockApi.ListStockProduct(item?.productDTO?.id);
        allStocks = stockResponse?.payload || [];
      } catch (error) {
        console.error('Error fetching initial stock:', error);
        // Continue with empty array if this fails
        allStocks = [];
      }

      // If barcode exists, try to get products with same barcode
      if (barCode) {
        try {
          const barCodeResponse = await ProductApi.GetByBarCode(barCode);
          barcodeProducts = barCodeResponse?.payloadDto;
          barcodeProducts = barcodeProducts.filter(product => {
            const productBarCode = extractCodeAfterHash(product.productCode);
            return productBarCode === barCode;
        });
          
          // If we have barcode products, fetch their stocks
          if (barcodeProducts.length > 0) {
            // Create stock promises for each product
            const stockPromises = barcodeProducts.map(product => 
              StockApi.ListStockProduct(product.id)
                .then(stockResponse => {
                  // Return both the product and its stocks
                  return {
                    productId: product.id,
                    stocks: stockResponse?.payload || [],
                    success: true
                  };
                })
                .catch(err => {
                  console.error(`Error fetching stock for product ${product.id}:`, err);
                  // Return failure but don't stop other promises
                  return {
                    productId: product.id,
                    stocks: [],
                    success: false,
                    error: err
                  };
                })
            );

            // Wait for all stock fetch promises to complete (some may fail)
            const results = await Promise.allSettled(stockPromises);
            
            // Extract stocks from successful results only
            results.forEach(result => {
              if (result.status === 'fulfilled' && result.value.success) {
                barcodeStocks = [...barcodeStocks, ...result.value.stocks];
              }
            });
          }
        } catch (barcodeError) {
          console.error('Error fetching barcode products:', barcodeError);
          // Continue with what we have
        }
      }

      // Combine all stocks and remove duplicates
      const combined = [...allStocks, ...barcodeStocks];
      const uniqueStocks = combined.filter(
        (item, index, self) => 
          index === self.findIndex(t => t.id === item.id)
      );

      // Log what we found for debugging
      console.log('Stock fetch summary:', {
        initialStockCount: allStocks.length,
        barcodeProductsFound: barcodeProducts.length,
        barcodeStocksFound: barcodeStocks.length,
        totalUniqueStocks: uniqueStocks.length
      });

      setStockProductNew(uniqueStocks);
      
    })
    .catch((err) => {
      console.error('Error fetching product details:', err);
      // If product details fails, we can't proceed
      notification.error({
        message: 'Error',
        description: 'Failed to fetch product details. Please try again.',
        duration: 3
      });
      setStockProductNew([]);
    })
    .finally(() => {
      setStockLoading(false);
    });
};

  const handlStockRecipeCloseModal = () => {
  setStockRecipe(false);

  setSelectedItems([]);
  setStockProductNew([]);
  setValidateAddStore([]);
  setStockRecordSelectedValid(false);
  setStockProduct2(null);
};

  const [modalStockRecipeUpdateVisible, setStockRecipeUpdate] = useState(false);

  const editStockRecipeNew = (item) => {
    const filterSelectStock = AfterStockProduct.filter(
      (items) => items?.id === item.id
    );

    setSelectedItems(filterSelectStock[0]?.ingredientsQuantityDTOList);

    const fieldsToUpdate = {};

    filterSelectStock[0]?.ingredientsQuantityDTOList.forEach(
      (ingredient, index) => {
        fieldsToUpdate[`createDate${ingredient.id}`] = parseFloat(
          ingredient.displayQuantity ?? ingredient.quantity
        );

        fieldsToUpdate[`unitOfMeasurement${ingredient.id}`] =
          ingredient.displayUnit ?? ingredient.unit;
              }
    );

    formAdd2.setFieldsValue(fieldsToUpdate);

    setStockRecipeUpdate(true);
    setStockRecipeData(item);
    StockApi.ListStockProduct(item?.productDTO?.id)
      .then((response) => {
        setStockProductNew(response?.payload || []);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handlStockRecipeUpdateCloseModal = () => {
    setStockRecipeUpdate(false);
    setStockRecordSelectedValid(true);
  };

  const [modalColdTraceVisible, setColdTraceVisible] = useState(false);
  const addColdTrace = () => {
    setColdTraceVisible(true);
  };
  const handlColdTraceCloseModal = () => {
    setColdTraceVisible(false);
  };

  const paginatedData = Ingredients.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  function convertToUnixTimestamp(dateString) {
    const parts = dateString.split("/");
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);

    const unixTimestamp = Date.UTC(year, month, day);
    return unixTimestamp;
  }

  const getConvertedQuantity = (item) => {
    if (!item?.productDTO) return item?.quantity;

    const { unit, quantity, productDTO } = item;
    const u1 = productDTO?.unitUomOne;
    const u2 = productDTO?.unitUomTwo;
    const u3 = productDTO?.unitUomThree;

    const m1 = Number(productDTO?.unitOfMeasurement1);
    const m2 = Number(productDTO?.unitOfMeasurement2);
    const m3 = Number(productDTO?.unitOfMeasurement3);

    if (unit === u1) return quantity / (m2 * m3);
    if (unit === u2) return (quantity / (m2 * m3)) * m2;
    if (unit === u3) return quantity;

    return quantity;
  };

  const renderTableRows = () => {
    if (paginatedData.length > 0) {
      return paginatedData.map((item) => (
        <tr key={item?.id} className="text-center">
          <td style={{ width: "20%" }} className="pt-3">
            {item?.name}
          </td>
          <td style={{ width: "10%" }} className="pt-3">
          {(function() {
              const value = parseFloat(getConvertedQuantity(item) || 1);
              const normalStr = value.toLocaleString('fullwide', { useGrouping: false, maximumFractionDigits: 20 });
              const match = normalStr.match(/^-?\d+(?:\.\d{0,3})?/);
              return match ? match[0] : '0';
            })()} {item?.unit}
          </td>

          <td style={{ width: "10%" }} className="pt-3">
            {item?.allergensDTO.length > 0 ? (
              <Tooltip
                placement="top"
                title={
                  <div>
                    {item?.allergensDTO?.map((allergen) => (
                      <React.Fragment key={allergen.id}>
                        {allergen.allergensName}
                        <br />
                      </React.Fragment>
                    ))}
                  </div>
                }
              >
                <InfoCircleFilled className="inforIcon" />
              </Tooltip>
            ) : null}
          </td>
          <td style={{ width: "5%" }} className="pt-3">
            {AfterStockProduct.some(
              (selectedItem) => selectedItem.id === item.id
            ) ? (
              <>
                <Tooltip
                  placement="top"
                  title={
                    <div>
                      {AfterStockProduct.filter(
                        (selectedItem) => selectedItem.id === item.id
                      ).map((selectedItem) =>
                        selectedItem.ingredientsQuantityDTOList.map((stock) => (
                          <React.Fragment key={stock.id}>
                            OUBD : {formatDate(stock.expiryDate)} <br />
                            Qty : {stock.displayQuantity ?? stock.quantity} {stock.displayUnit ?? stock.unit}
                            <br />
                            Batch Code : {stock.batchCode}
                            <hr />
                          </React.Fragment>
                        ))
                      )}
                    </div>
                  }
                >
                  <FileSearchOutlined className="inforIcon" />
                </Tooltip>
                <PlusCircleFilled
                  className="PlusAddIcon"
                  onClick={() => editStockRecipeNew(item)}
                />
              </>
            ) : (
              <PlusCircleFilled
                className="PlusAddIcon"
                onClick={() => addStockRecipe(item)}
              />
            )}
          </td>
        </tr>
      ));
    } else {
      return (
        <tr className="text-center EmptyTable">
          <td colSpan={6} className="text-center ">
            <EmptyBox />
          </td>
        </tr>
      );
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };
  const [startDate, setStartDate] = useState(dayjs(currentDate, "DD/MM/YYYY"));
  const [endDate, setEndDate] = useState(null);

  const handleStartDateChange = (date) => {
    setStartDate(date);
    calculateDateDifference();
  };

  const handleEndDateChange = (date) => {
    setEndDate(moment(date));
    calculateDateDifference();

    setSellByDay(calculateDateDifference());
  };

  const calculateDateDifference = () => {
    if (startDate && endDate) {
      const differenceInMilliseconds = Math.abs(endDate - startDate);
      const daysDifference = Math.ceil(
        differenceInMilliseconds / (1000 * 60 * 60 * 24)
      );
      formAdd.setFieldsValue({
        sellDate: "Sell By Date(" + daysDifference + " days)",
      });
      return daysDifference;
    }
    return 0;
  };

  const handleChangeRecipe = (value) => {
    RecipeApi.SingleRecipe(value)
      .then((response) => {
        setSelectRecipe(response?.payload);
        setIngredients(response?.payload?.ingredientsDTO);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChangeModify = (item) => {
    setSelectedItems((prevSelectedItems) => {
      const index = prevSelectedItems.findIndex(
        (selectedItem) => selectedItem.id === item.id
      );
      if (index === -1) {
        if ([...prevSelectedItems, item].length > 0) {
          setStockRecordSelectedValid(true);
        } else {
          setStockRecordSelectedValid(false);
        }
        return [...prevSelectedItems, item];
      } else {
        const updatedItems = [...prevSelectedItems];
        updatedItems.splice(index, 1);
        if (updatedItems.length > 0) {
          setStockRecordSelectedValid(true);
        } else {
          setStockRecordSelectedValid(false);
        }
        return updatedItems;
      }
    });
  };
  const handleInputKeyDown = (event) => {
    if (event.key === "-") {
      event.preventDefault();
    }
  };

  const handleInputChange = (event, itemId, productDetails) => {
  const value = parseFloat(event.target.value) || 0;

  const u1 = productDetails.unitUomOne;
  const u2 = productDetails.unitUomTwo;
  const u3 = productDetails.unitUomThree;

  setSelectedItems(prev =>
    prev.map(item => {

      if (item.id !== itemId.id) return item;

      let baseQty = value;

      if (item.unit === u1) {
        baseQty = value * parseFloat(productDetails.unitOfMeasurement2);
      } else if (item.unit === u2) {
        baseQty = value;
      } else if (item.unit === u3) {
        baseQty = value / parseFloat(productDetails.unitOfMeasurement3);
      }

      return {
      ...item,
      quantity: baseQty,        
      baseQuantity: baseQty,
      displayQuantity: value,   
      displayUnit: item.unit,
      stockId: item.id, 
    };
    })
  );
};

  const handleInputChange2 = (event, itemId) => {
    const newItem = event.target.value.trim();
    setSelectedItems((prevSelectedItems) => {
      const updatedItems = prevSelectedItems.map((selectedItem) => {
        if (selectedItem.id === itemId.id) {
          return {
          ...selectedItem,
          quantity: newItem,
          displayQuantity: parseFloat(event.target.value.trim()),
          displayUnit: selectedItem.unit
        };
        }
        return selectedItem;
      });
      return updatedItems;
    });
  };
  const handleSelectChange = (event, itemId, productDetails = StockProduct2) => {
  const u1 = productDetails?.unitUomOne;
  const u2 = productDetails?.unitUomTwo;
  const u3 = productDetails?.unitUomThree;

  setSelectedItems((prevSelectedItems) => {
    return prevSelectedItems.map((selectedItem) => {

      if (selectedItem.id !== itemId.id) return selectedItem;

      // Use what the user typed, NOT the previously converted quantity
      const value = parseFloat(selectedItem.displayQuantity || 0);

      let baseQty = value;

      if (event === u1) {
        baseQty =
          value * parseFloat(productDetails.unitOfMeasurement2);
      } else if (event === u2) {
        baseQty = value;
      } else {
        baseQty =
          value / parseFloat(productDetails.unitOfMeasurement3);
      }

      return {
        ...selectedItem,
        unit: event,
        quantity: value,
        baseQuantity: baseQty,
        displayUnit: event,
        stockId: selectedItem.id,
      };
    });
  });
};

  const changeTotal = () => {
    const newItem = selectedItems.reduce(
      (total, item) => total + parseFloat(item.quantity || 0),
      0
    );
    return newItem;
  };

  const [AfterStockProduct, setAfterStockProduct] = React.useState([]);

  const [StockRecordSelectedValid, setStockRecordSelectedValid] =
    React.useState(false);
  const [ValidateAddStore, setValidateAddStore] = React.useState([]);

 const StoreStock = (dataid) => {
  setStockRecordSelectedValid(true);
  const errors = [];
  let totalQty = 0;
  setValidateAddStore([]);
  selectedItems.forEach((item2) => {
    // Get the actual stock quantity in the selected unit
    let stockQuantityInSelectedUnit;
    
    if (item2.unit === StockProduct2?.unitUomOne) {
      // If selected unit is UOM1 (BOX), use UOM1 quantity directly
      stockQuantityInSelectedUnit = parseFloat(item2?.unitOfMeasurement1);
    } else if (item2.unit === StockProduct2?.unitUomTwo) {
      // If selected unit is UOM2 (PACKET), calculate from UOM1
      stockQuantityInSelectedUnit = parseFloat(item2?.unitOfMeasurement1) * parseFloat(StockProduct2?.unitOfMeasurement2 || 1);
    } else {
      // For other units (like UOM3), calculate appropriately
      stockQuantityInSelectedUnit = parseFloat(item2?.unitOfMeasurement1);
    }

    if (parseFloat(item2.baseQuantity) > stockQuantityInSelectedUnit) {
      errors.push(
        `Insufficient stock for product, Please update the stock first for batchCode ${item2.batchCode}`
      );
    }
  });

  setValidateAddStore(errors);
  if (errors.length === 0) {
    const ingredientsWithStockId = selectedItems.map(item => ({
    ...item,
    stockId: item.id,
    quantity: item.baseQuantity,   // send converted quantity
  }));

    setAfterStockProduct([
      ...AfterStockProduct,
      {
        id: dataid?.id,
        costPrice: parseFloat(StockProduct2?.costPriceUoM2) * changeTotal(),
        ingredientsQuantityDTOList: ingredientsWithStockId,
      },
    ]);
    setStockRecipe(false);
    setSelectedItems([]);
  }
};

  const UpdateStock = (dataid) => {
  setStockRecordSelectedValid(true);
  const errors = [];
  setValidateAddStore([]);
  selectedItems.forEach((item2) => {
    let stockQuantityInSelectedUnit;
    
    if (item2.unit === StockProduct2?.unitUomOne) {
      // If selected unit is UOM1 (BOX), use UOM1 quantity directly
      stockQuantityInSelectedUnit = parseFloat(item2?.unitOfMeasurement1);
    } else if (item2.unit === StockProduct2?.unitUomTwo) {
      // If selected unit is UOM2 (PACKET), calculate from UOM1
      stockQuantityInSelectedUnit = parseFloat(item2?.unitOfMeasurement1) * parseFloat(StockProduct2?.unitOfMeasurement2 || 1);
    } else {
      // For other units (like UOM3), calculate appropriately
      stockQuantityInSelectedUnit = parseFloat(item2?.unitOfMeasurement1);
    }

    if (parseFloat(item2.quantity) > stockQuantityInSelectedUnit) {
      errors.push(
        `Insufficient stock for product, Please update the stock first for batchCode ${item2.batchCode}`
      );
    }
  });

  setValidateAddStore(errors);
  const index = AfterStockProduct.findIndex((item) => item.id === dataid?.id);

  if (index !== -1) {
    const ingredientsWithStockId = selectedItems.map(item => ({
    ...item,
    stockId: item.id,
    quantity: item.baseQuantity,
  }));

    const updatedItem = {
      ...AfterStockProduct[index],
      costPrice: parseFloat(StockProduct2?.costPriceUoM2) * changeTotal(),
      ingredientsQuantityDTOList: ingredientsWithStockId,
    };

    const updatedArray = [...AfterStockProduct];
    updatedArray[index] = updatedItem;

    if (errors.length === 0) {
      setAfterStockProduct(updatedArray);
      setStockRecipeUpdate(false);
      setSelectedItems([]);
    }
  }
};

  function formatDate(date) {
    const dateNew = parseInt(date, 10);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = new Date(dateNew).toLocaleDateString(
      "en-US",
      options
    );

    const [month, day, year] = formattedDate.split(" ");

    const capitalizedMonth = month.toUpperCase();

    return `${day} ${capitalizedMonth} ${year}`;
  }
  const validateInputNumber = (_, value) => {
    if (value >= 0 && value != "") {
      return Promise.resolve();
    }
    return Promise.reject();
  };
  const changeTotalCost = () => {
    const newItem = AfterStockProduct.reduce(
      (total, item) => total + parseFloat(item.costPrice || 0),
      0
    );
    return newItem;
  };

  // ✅ FIXED: Products expiring today are treated as still valid (not expired).
  function compareDates(creationDate) {
    const today = dayjs().startOf('day');
    const itemDate = dayjs(creationDate).endOf('day');
    // Only expired if the expiry day is strictly BEFORE today.
    return itemDate.isBefore(today, 'day');
  }

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>
            <Form
              form={formAdd}
              name="nest-messages"
              layout="vertical"
              className="FormClass"
              onFinish={handleSubmit}
            >
              <>
                <Row gutter={24}>
                  <Col span={12}>
                    <Form.Item
                      name="type"
                      label=" "
                      className="text-lable ProductionSearch"
                      rules={[
                        {
                          required: true,
                          message: "Please Select Recipe",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        className="control-Select mb-1"
                        placeholder="Select Recipe"
                        onPopupScroll={handleScroll}
                        onChange={(value) => handleChangeRecipe(value)}
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {Recipes.map((option, index) => (
                          <Select.Option key={option.id} value={option.id}>
                            {option.recipeName}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={12} className="d-flex">
                    <Form.Item
                      name="prodDate"
                      label=" "
                      initialValue={dayjs(currentDate, "DD/MM/YYYY")}
                      className="text-lable  d-none"
                      rules={[
                        {
                          required: true,
                          message: "Please Select Open UBD",
                        },
                      ]}
                    >
                      <DatePicker
                        format={"DD/MM/YYYY"}
                        onChange={handleStartDateChange}
                        className="form-control control-input"
                      />
                    </Form.Item>
                    <div
                      className="px-3  mt-2"
                      style={{
                        display: "flex",
                        fontSize: "18px",
                        alignItems: "center",
                      }}
                    >
                      <b className="mx-3">{currentDate}</b>
                      <img
                        src="/assest/Images/cal.png"
                        style={{ width: "34px" }}
                        className="logo-png"
                      />
                    </div>

                    <Form.Item
                      name="prodTime"
                      label=" "
                      initialValue={dayjs(currentTime, "h:mm a")}
                      className="text-lable d-none"
                      rules={[
                        {
                          required: true,
                          message: "Please select Sell Date",
                        },
                      ]}
                    >
                      <TimePicker
                        use12Hours
                        format="h:mm a"
                        className="form-control control-input"
                      />
                    </Form.Item>
                    <div
                      className="p-3 mt-2"
                      style={{
                        display: "flex",
                        fontSize: "18px",
                        alignItems: "center",
                      }}
                    >
                      <b>{formattedTimeNew}</b>{" "}
                      <img
                        src="/assest/Images/time.png"
                        style={{ width: "35px" }}
                        className="logo-png mx-2"
                      />
                    </div>
                  </Col>
                  <Col lg={3} md={0}></Col>

                  <Col span={24} className="pt-3">
                    <table className="table users-table">
                      <thead>
                        <tr>
                          <th>Ingredient</th>
                          <th>Quantity</th>
                          <th>Allergens</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>{renderTableRows()}</tbody>
                    </table>
                  </Col>
                  <Col lg={5} md={4}></Col>
                  <Col lg={9} md={9}>
                    <Form.Item name="sellDate" label=" " className="text-lable">
                      <Input
                        readOnly
                        value={`Sell By Date(${calculateDateDifference()}) days`}
                        type="text"
                        className="control-input"
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={5} md={8} className="d-flex">
                    <Form.Item
                      name="SellDate"
                      label=" "
                      className="text-lable "
                      rules={[
                        {
                          required: true,
                          message: "Please Select Sell By Date",
                        },
                      ]}
                    >
                      <Input
                        type="date"
                        onChange={(e) => handleEndDateChange(e.target.value)}
                        placeholder="Text"
                        className="control-input"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <div className="d-flex justify-content-center pt-5">
                  <Space size="large" align="center">
                    {decodedToken?.permissions?.some(
                      permission => permission?.authority === 'ADD_PRODUCT'
                    ) && (
                        <Button
                          onClick={handleGoBack}
                          type="default"
                          disabled={isSubmitting}
                          style={{
                            height: '50px',
                            lineHeight: 'normal',
                            padding: '6px 30px',
                            fontWeight: 500,
                          }}
                        >
                          Cancel
                        </Button>
                      )}

                    {SelectRecipe?.refrigeratedMeal === true ? (
                      <Button
                        type="primary"
                        loading={isSubmitting}
                        disabled={isSubmitting}
                        onClick={addColdTrace}
                        style={{
                          height: '50px',
                          lineHeight: 'normal',
                          padding: '6px 30px',
                          fontWeight: 500,
                        }}
                      >
                        Cold
                      </Button>
                    ) : (
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={isSubmitting}
                        disabled={isSubmitting}
                        style={{
                          height: '50px',
                          lineHeight: 'normal',
                          padding: '6px 30px',
                          fontWeight: 500,
                        }}
                      >
                        Cook
                      </Button>
                    )}
                  </Space>
                </div>

              </>
            </Form>
          </div>
        </Content>
        <Modal
          footer={[]}
          width={600}
          visible={modalColdTraceVisible}
          maskClosable={false}
          onCancel={handlColdTraceCloseModal}
        >
          <Title level={4} className="text-center Primary-Font mb-4 pb-3">
            Select storage
          </Title>
          <Form
            form={formAdd}
            name="nest-messages"
            layout="horizontal"
            id="SelectClassPrduction"
            labelCol={{
              span: 9,
            }}
            wrapperCol={{
              span: 15,
            }}
            className="FormClass SlectNew IndividualProduct-Model"
            onFinish={handleSubmit}
          >
            <>
              <StorageSelectProduction />

              <div className="d-flex justify-content-center pt-4">
                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save mx-2"
                  style={{ width: "37%" }}
                >
                  Add
                </Button>
              </div>
            </>
          </Form>
        </Modal>

        <Modal
          footer={[]}
          width={1400}
          visible={modalStockRecipeVisible}
          maskClosable={false}
          onCancel={handlStockRecipeCloseModal}
        >
          <div
            className="m-4"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Title level={4} className=" Primary-Font m-0">
              Add {StockRecipeDatas?.name} from Stock
            </Title>
            <Title level={4} className=" Primary-Font m-0">
              {getConvertedQuantity(StockRecipeDatas)} {StockRecipeDatas?.unit}
            </Title>
          </div>

          <Form
            name="nest-messages"
            layout="horizontal"
            labelCol={{
              span: 9,
            }}
            wrapperCol={{
              span: 15,
            }}
            className="FormClass IndividualProduct-Model"
            onFinish={() => StoreStock(StockRecipeDatas)}
          >
            <>
              <div className="dateFilterTable">
                <table className="table users-table">
                  <thead>
                    <tr style={{ verticalAlign: "top" }}>
                      <th className="text-center"></th>
                      <th>Invoice #</th>
                      <th>Batch Code</th>
                      <th className="text-center">Status</th>
                      <th className="text-center">
                        OUBD
                        <br />{" "}
                        <p
                          className="mb-0 pb-0"
                          style={{ color: "gray", fontSize: "12px" }}
                        >
                          (Original Used by Date)
                        </p>
                      </th>

                      <th className="text-center">Qty(UOM2)</th>
                      <th>Qty(UOM3)</th>
                      <th className="text-center"> Adding Qty</th>
                    </tr>
                  </thead>

                  <tbody
                    className={StockProductNew?.length > 6 ? "tableScroll" : ""}
                  >
                    {getFilteredStockProduct().map((item, index) => {
                        if (compareDates(formatDate(item?.expiryDate))) return null;

                      return (
                        <tr
                          style={{ cursor: "pointer" }}
                        >
                          <td
                            className="CleanTable px-2 PnameClass"
                            style={{ width: "10%", textAlign: "start" }}
                          >
                            <Form.Item
                              name={`selectedCheck${item.id}`}
                              className="text-lable mx-2 "
                            >
                              <Checkbox
                                className="custom-checkbox"
                                disabled={compareDates(
                                  formatDate(item?.expiryDate)
                                )}
                                checked={selectedItems.some(
                                  (selectedItem) => selectedItem.id === item.id
                                )}
                                onChange={() => handleChangeModify(item)}
                              ></Checkbox>
                            </Form.Item>
                          </td>
                          <td
                            className="CleanTable px-2 text-start PnameClass"
                            style={{ width: "10%", textAlign: "start" }}
                          >
                            {item?.invoiceNumber}
                          </td>
                          <td>
                            <div style={{
                              overflowX: 'auto',
                              overflowY: 'hidden',
                              whiteSpace: 'nowrap',
                              maxWidth: '200px',
                              marginBottom: '10px',
                              marginTop: '-3px',
                              padding: '0px 0px 20px',
                              display: 'block',
                            }}>
                              {item?.batchCode || '-'}
                            </div>
                          </td>
                          <td
                            className="CleanTable px-2 PnameClass"
                            style={{ width: "10%", textAlign: "center" }}
                          >
                            {item?.openUBD ? (
                              <>
                                {StockRecipeDatas?.ingredientsStatus}
                                <br />{" "}
                                <p
                                  className="mb-0 pb-0"
                                  style={{ color: "gray", fontSize: "12px" }}
                                >
                                  ( {formatDate(item?.openUBD)}){" "}
                                </p>
                              </>
                            ) : (
                              <>NOT OPEN</>
                            )}
                          </td>
                          <td
                            className="CleanTable px-2 PnameClass text-center"
                            style={{ width: "10%", textAlign: "start" }}
                          >
                            {formatDate(item?.expiryDate)}
                          </td>

                          <td style={{ width: '10%', textAlign: 'end' }} className="CleanTable PnameClass">
                            {(function() {
                                const value = parseFloat(item?.unitOfMeasurement1 || 1);
                                const normalStr = value.toLocaleString('fullwide', { useGrouping: false, maximumFractionDigits: 20 });
                                const match = normalStr.match(/^-?\d+(?:\.\d{0,2})?/);
                                return match ? match[0] : '0';
                              })()} {StockProduct2?.unitUomTwo}
                          </td>
                            
                          <td style={{ width: '10%', textAlign: 'end' }} className="CleanTable PnameClass">
                           
                            {(function() {
                                const value = parseFloat(item?.unitOfMeasurement1 || 1) * parseFloat(StockProduct2?.unitOfMeasurement3 || 1);
                                const normalStr = value.toLocaleString('fullwide', { useGrouping: false, maximumFractionDigits: 20 });
                                const match = normalStr.match(/^-?\d+(?:\.\d{0,2})?/);
                                return match ? match[0] : '0';
                              })()} {StockProduct2?.unitUomThree}
                         
                          </td>

                          <td
                            style={{ width: "10%" }}
                            className="CleanTable PnameClass AddingQty"
                          >
                            <div style={{ display: "flex" }}>
                              <Form.Item
                                name={`createDate${item.id}`}
                                className="text-lable mx-2"
                                rules={
                                  selectedItems.some(
                                    (selectedItem) =>
                                      selectedItem.id === item.id
                                  )
                                    ? [{ validator: validateInputNumber }]
                                    : []
                                }
                              >
                                <Input
                                  type="number"
                                  style={{ textAlign: "right", width: "80px" }}
                                  disabled={
                                    !selectedItems.some(
                                      (selectedItem) =>
                                        selectedItem.id === item.id
                                    )
                                  }
                                  onChange={(event) =>
                                    handleInputChange(event, item, StockProduct2)
                                  }
                                  onKeyDown={handleInputKeyDown}
                                />
                              </Form.Item>
                              <Form.Item
                                name={`unitOfMeasurement${item.id}`}
                                className="text-lable  "
                                rules={
                                  selectedItems.some(
                                    (selectedItem) =>
                                      selectedItem.id === item.id
                                  )
                                    ? [
                                      {
                                        required: true,
                                        message: "",
                                      },
                                    ]
                                    : []
                                }
                              >
                                <Select
                                  className="control-Select mb-1"
                                  style={{ width: "80px" }}
                                  placeholder="-"
                                  onChange={(event) =>
                                    handleSelectChange(event, item, StockProduct2)
                                  }
                                  disabled={
                                    !selectedItems.some(
                                      (selectedItem) =>
                                        selectedItem.id === item.id
                                    )
                                  }
                                >
                                  <option value={StockProduct2?.unitUomOne}>
                                    {StockProduct2?.unitUomOne}
                                  </option>
                                  <option value={StockProduct2?.unitUomTwo}>
                                    {" "}
                                    {StockProduct2?.unitUomTwo}
                                  </option>
                                  {StockProduct2.unitOfMeasurement3 != 1 && (
                                    <option value={StockProduct2?.unitUomThree}>
                                      {StockProduct2?.unitUomThree}
                                    </option>
                                  )}
                                </Select>
                              </Form.Item>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                    {stockLoading ? (
                    <tr>
                        <td colSpan={9} className="text-center" style={{ padding: "30px" }}>
                            <div className="spinner"></div>
                            Loading stock items...
                        </td>
                    </tr>
                ) : (
                    (getFilteredStockProduct().length === 0 && !stockLoading) && (
                        <tr>
                            <td colSpan={9} className="text-center" style={{ padding: "30px", color: "#999" }}>
                                <ShoppingOutlined 
                                    style={{ 
                                        fontSize: "32px", 
                                        display: "block", 
                                        marginBottom: "12px" 
                                    }} 
                                />
                                No stock items available
                            </td>
                        </tr>
                    )
                )}
                  </tbody>
                </table>
              </div>
              <p
                style={{ color: "red" }}
                className={!StockRecordSelectedValid ? "mb-2" : "d-none"}
              >
                Please select at least one stock record.
              </p>
              {ValidateAddStore.length > 0 && (
                <>
                  {ValidateAddStore.map((errorMessage, index) => (
                    <p key={index} style={{ color: "red" }}>
                      {errorMessage}
                    </p>
                  ))}
                </>
              )}

              <div
                className="d-flex justify-content-between pt-4"
                style={{
                  gap: "10px",
                  padding: "16px 24px 0",
                }}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={stockLoading}
                  disabled={stockLoading || selectedItems.length === 0}
                  style={{
                    flex: 1,
                    height: 40,
                    borderRadius: 6,
                    fontWeight: 500,
                  }}
                >
                  Add quantities to production
                </Button>
              </div>

            </>
          </Form>
        </Modal>

        <Modal
          footer={[]}
          width={1000}
          visible={modalStockRecipeUpdateVisible}
          maskClosable={false}
          onCancel={handlStockRecipeUpdateCloseModal}
        >
          <div
            className="m-4"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Title level={4} className=" Primary-Font m-0">
              Edit {StockRecipeDatas?.name} from Stock
            </Title>
            <Title level={4} className=" Primary-Font m-0">
              {getConvertedQuantity(StockRecipeDatas)} {StockRecipeDatas?.unit}
            </Title>
          </div>
          <Form
            form={formAdd2}
            name="nest-messages"
            layout="horizontal"
            onFinish={() => UpdateStock(StockRecipeDatas)}
            labelCol={{
              span: 9,
            }}
            wrapperCol={{
              span: 15,
            }}
            className="FormClass IndividualProduct-Model"
          >
            <>
              <div className="dateFilterTable">
                <table className="table users-table">
                  <thead>
                    <tr style={{ verticalAlign: "top" }}>
                      <th className="text-center"></th>
                      <th>Invoice #</th>
                      <th>Batch Code</th>
                      <th className="text-center">Status</th>
                      <th className="text-center">
                        OUBD
                        <br />{" "}
                        <p
                          className="mb-0 pb-0"
                          style={{ color: "gray", fontSize: "12px" }}
                        >
                          (Original Used by Date)
                        </p>
                      </th>
                      <th className="text-center">Qty(UOM1)</th>
                      <th>Qty(UOM2)</th>
                      <th className="text-center"> Adding Qty</th>
                    </tr>
                  </thead>

                  <tbody
                    className={StockProductNew?.length > 6 ? "tableScroll" : ""}
                  >
                    {getFilteredStockProduct().map((item, index) => {
                        
                      if (compareDates(formatDate(item?.expiryDate))) return null;

                      return (
                        <>
                        <tr style={{ cursor: "pointer" }}>

                          <td
                            className="CleanTable px-2 PnameClass"
                            style={{ width: "10%", textAlign: "start" }}
                          >
                            <Checkbox
                              checked={selectedItems.some(
                                (selectedItem) => selectedItem.id === item.id
                              )}
                              onChange={() => handleChangeModify(item)}
                            ></Checkbox>
                          </td>
                          <td
                            className="CleanTable px-2 text-start PnameClass"
                            style={{ width: "10%", textAlign: "start" }}
                          >
                            {item?.invoiceNumber}
                          </td>
                          <td
                            style={{ width: "10%", textAlign: "start" }}
                            className="CleanTable text-start PnameClass"
                          >
                            <div style={{
                              overflowX: 'auto',
                              overflowY: 'hidden',
                              whiteSpace: 'nowrap',
                              maxWidth: '200px',
                              marginBottom: '10px',
                              marginTop: '-3px',
                              padding: '0px 0px 20px',
                              display: 'block',
                            }}>
                              {item?.batchCode || '-'}
                            </div>
                          </td>
                          <td
                            className="CleanTable px-2 PnameClass"
                            style={{ width: "10%", textAlign: "center" }}
                          >
                            {item?.openUBD ? (
                              <>
                                {StockRecipeDatas?.ingredientsStatus}
                                <br />{" "}
                                <p
                                  className="mb-0 pb-0"
                                  style={{ color: "gray", fontSize: "12px" }}
                                >
                                  ( {formatDate(item?.openUBD)}){" "}
                                </p>
                              </>
                            ) : (
                              <>NOT OPEN</>
                            )}
                          </td>
                          <td
                            className="CleanTable px-2 PnameClass text-center"
                            style={{ width: "10%", textAlign: "start" }}
                          >
                            {formatDate(item?.expiryDate)}
                          </td>

                            <td
                            style={{ width: "10%", textAlign: "end" }}
                            className="CleanTable PnameClass"
                          >
                            {(() => {
                              const value = parseFloat(item?.unitOfMeasurement1);
                              return `${value.toFixed(3)} ${item?.unit}`;
                            })()}
                          </td>

                          <td
                            style={{ width: "10%", textAlign: "end" }}
                            className="CleanTable PnameClass"
                          >
                            {(() => {
                              const value = parseFloat(item?.unitOfMeasurement1) * parseFloat(StockProduct2?.unitOfMeasurement3 || 1);
                              return `${value.toFixed(3)} ${StockProduct2?.unitUomThree}`;
                            })()}
                          </td>

                        
                          <td
                            style={{ width: "10%" }}
                            className="CleanTable PnameClass AddingQty"
                          >
                            <div style={{ display: "flex" }}>
                              <Form.Item
                                name={`createDate${item.id}`}
                                className="text-lable mx-2"
                                rules={
                                  selectedItems.some(
                                    (selectedItem) =>
                                      selectedItem.id === item.id
                                  )
                                    ? [{ validator: validateInputNumber }]
                                    : []
                                }
                              >
                                <Input
                                  type="number"
                                  style={{ textAlign: "right", width: "80px" }}
                                  defaultValue={0}
                                  disabled={
                                    !selectedItems.some(
                                      (selectedItem) =>
                                        selectedItem.id === item.id
                                    )
                                  }
                                  onChange={(event) =>
                                    handleInputChange2(event, item)
                                  }
                                  onKeyDown={handleInputKeyDown}
                                />
                              </Form.Item>
                              <Form.Item
                                name={`unitOfMeasurement${item.id}`}
                                className="text-lable  "
                                rules={
                                  selectedItems.some(
                                    (selectedItem) =>
                                      selectedItem.id === item.id
                                  )
                                    ? [
                                      {
                                        required: true,
                                        message: "",
                                      },
                                    ]
                                    : []
                                }
                              >
                                <Select
                                  className="control-Select mb-1"
                                  style={{ width: "80px" }}
                                  placeholder="-"
                                  onChange={(event) =>
                                    handleSelectChange(event, item, StockProduct2)
                                  }
                                  disabled={
                                    !selectedItems.some(
                                      (selectedItem) => selectedItem.id === item.id
                                    )
                                  }
                                >
                                  <Select.Option value={StockProduct2?.unitUomOne}>
                                    {StockProduct2?.unitUomOne}
                                  </Select.Option>

                                  <Select.Option value={StockProduct2?.unitUomTwo}>
                                    {StockProduct2?.unitUomTwo}
                                  </Select.Option>

                                  {StockProduct2?.unitOfMeasurement3 != 1 && (
                                    <Select.Option value={StockProduct2?.unitUomThree}>
                                      {StockProduct2?.unitUomThree}
                                    </Select.Option>
                                  )}
                                </Select>
                              </Form.Item>
                            </div>
                          </td>
                        </tr>
                      </>
                       );
                    })}
                  </tbody>
                </table>
              </div>

              <p
                style={{ color: "red" }}
                className={!StockRecordSelectedValid ? "mb-2" : "d-none"}
              >
                Please select at least one stock record.
              </p>
              {ValidateAddStore.length > 0 && (
                <>
                  {ValidateAddStore.map((errorMessage, index) => (
                    <p key={index} style={{ color: "red" }}>
                      {errorMessage}
                    </p>
                  ))}
                </>
              )}
              <div className="d-flex justify-content-center pt-4">
                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save mx-2"
                  style={{ width: "37%" }}
                >
                  Update
                </Button>
              </div>
            </>
          </Form>
        </Modal>

        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default ListProduction;